// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import NodeViewModel from "./../../factories/node-view-model";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabPage from "./../../factories/tab-page";
import BaoDialogViewModel from "./../../factories/bao-dialog";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/sorting";
import AppTabController from "../../services/app-tab-controller";
function ConfigurationItemPersonTabModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.ServiceProvider = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.PersonCollection = ko.observableArray([]);
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteConfigurationItemServiceProvider");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "ConfigurationItemServiceProviderPersonAdd":
                self.AddNewConfigurationItemPerson();
                break;
            case "ConfigurationItemServiceProviderAdd":
                self.ShowConfigurationItemServiceProviderDialog();
                break;
            case "ConfigurationItemServiceProviderEdit":
                if (self.SelectedPersonRow() != null) {
                    self.ShowConfigurationItemPersonTab(self.SelectedPersonRow());
                }
                break;
            case "ConfigurationItemServiceProviderDelete":
                if (self.SelectedPersonRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteConfigurationItemPerson(self.ServiceProvider.ServiceProviderId(), self.SelectedPersonRow().OpenData);
                        }
                    });
                }
                break;
        }
    };
    self.SelectedPersonId = ko.observable();
    self.SelectedPerson = ko.observable();
    self.SelectedPerson.subscribe(function () {
        self.AddConfigurationItemPerson(self.SelectedPersonId(), self.ServiceProvider.ServiceProviderId());
    });
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ServiceProviderTab/GetConfigurationItemPersonCollection", JSON.stringify({
            sessionTabId: self.ServiceProvider.TabPage.SessionTabId,
            serviceProviderId: self.ServiceProvider.ServiceProviderId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedPersonRow(null);
            self.TotalRows(0);
            self.PersonCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.PersonCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
            self.ToggleToolbarButtons();
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddNewConfigurationItemPerson = function () {
        var newTab = new TabPage("ConfigurationItem/Person");
        newTab.Url("ConfigurationItem/Person");
        newTab.IsClosable(true);
        newTab.EnableDirtyTracking(true);
        newTab["Object"] = {
            ServiceProviderId: self.ServiceProvider.ServiceProviderId()
        };
        newTab.TabLoaded = function () { };
        AppTabController.AddTab(newTab);
    };
    self.AddConfigurationItemPerson = function (configurationItemId, serviceProviderId) {
        tabPage.IsLoading(true);
        return Bao.post("ServiceProviderTab/AddConfigurationItemPerson", JSON.stringify({
            sessionTabId: self.ServiceProvider.TabPage.SessionTabId,
            configurationItemId: configurationItemId,
            serviceProviderId: serviceProviderId
        }), function () {
            self.ServiceProvider.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.DeleteConfigurationItemPerson = function (serviceProviderId, configurationItemPersontId) {
        return Bao.post("ServiceProviderTab/DeleteConfigurationItemPerson", JSON.stringify({
            sessionTabId: self.ServiceProvider.TabPage.SessionTabId,
            serviceProviderId: serviceProviderId,
            configurationItemPersontId: configurationItemPersontId
        }), function () {
            self.ServiceProvider.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.ShowConfigurationItemPersonTab = function (item) {
        if (item != null) {
            var newTab = new TabPage();
            newTab.Url("ConfigurationItem/Person");
            newTab.UrlData({
                id: item.ConfigurationItemId
            });
            newTab.ObjectId(item.ConfigurationItemId);
            AppTabController.AddTab(newTab);
        }
    };
    self.ShowConfigurationItemServiceProviderDialog = function () { };
    self.ToolbarButtons = ko.observableArray([]);
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectedPersonRow = ko.observable({});
    self.SelectedPersonRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "ConfigurationItemServiceProviderEdit":
                case "ConfigurationItemServiceProviderDelete":
                    button.Enabled(!(self.SelectedPersonRow() == null));
                    break;
                case "ConfigurationItemServiceProviderPersonAdd":
                    button.Enabled(!self.ServiceProvider.IsNew());
                    break;
            }
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("ServiceProviderTab/ResetConfigurationItemPerson", JSON.stringify({
            sessionTabId: self.ServiceProvider.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("ServiceProviderTab/SaveConfigurationItemPersonCollection", JSON.stringify({
            sessionTabId: self.ServiceProvider.TabPage.SessionTabId,
            serviceProviderId: self.ServiceProvider.ServiceProviderId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.init = function () {
        return self.Refresh();
    };
    self.loaded = function () {
        self.ToggleToolbarButtons();
    };
}
;
export default ConfigurationItemPersonTabModel;